import {
  createCampaign,
  deleteCampaign,
  getAllProperty,
  getDetailCampaign,
  getlistCampaign,
  updateCampaign,
} from '../../data/marketing/campaign';
import { setLoading, setLoadingTable } from '../../redux/layout/layout.actions';

export const UGetlistCampaign = (params: any) => async (dispatch: any) => {
  try {
    dispatch(setLoadingTable(true));
    const res = await getlistCampaign(params);
    return res;
  } catch (error) {
    return Promise.reject(error);
  } finally {
    dispatch(setLoadingTable(false));
  }
};

export const UGetDetailCampaign = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const res = await getDetailCampaign(id);
    return res;
  } catch (error) {
    return Promise.reject(error);
  } finally {
    dispatch(setLoading(false));
  }
};

export const UCreateCampaign = (data: any) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const res = await createCampaign(data);
    return res;
  } catch (error) {
    return Promise.reject(error);
  } finally {
    dispatch(setLoading(false));
  }
};

export const UUpdateCampaign = (id: string, data: any) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const res = await updateCampaign(id, data);
    return res;
  } catch (error) {
    return Promise.reject(error);
  } finally {
    dispatch(setLoading(false));
  }
};

export const UDeleteCampaign = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoadingTable(true));
    const res = await deleteCampaign(id);
    return res;
  } catch (error) {
    return Promise.reject(error);
  } finally {
    dispatch(setLoadingTable(false));
  }
};

export const UGetListProperty = (params: { q?: string }) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const res = await getAllProperty(params);
    return res;
  } catch (error) {
    return Promise.reject(error);
  } finally {
    dispatch(setLoading(false));
  }
};
